import dayjsImport from "./auth-service-tools36.js";

function isMonthDisabled(month, minDate, maxDate) {
  if (!minDate && !maxDate) {
    return false;
  }

  if (minDate && dayjsImport(month).isBefore(minDate, "month")) {
    return true;
  }

  if (maxDate && dayjsImport(month).isAfter(maxDate, "month")) {
    return true;
  }

  return false;
}

export { isMonthDisabled };